import { extractIdFromGid } from "./constant";

/**
 * Divide Shopify collections into hierarchy buckets by title convention.
 *
 * Level 1: "Tiles"
 * Level 2: "Tiles > Floor Tiles"
 * Level 3: "Tiles > Floor Tiles > Vitrified Tiles"
 * Special: titles starting with "__"
 */
export const divideCategories = (collections) => {
  const parentCategories = [];
  const childCategories = [];
  const thirdChildCategories = [];
  const otherCategories = [];

  // Shallow clone so we can attach hierarchy fields without mutating API rows
  const nodes = (collections || []).map((collection) => ({ ...collection }));

  nodes.forEach((collection) => {
    const string = collection?.title || "";
    if (string.includes(">")) {
      // handled in later passes
    } else if (string.startsWith("__")) {
      otherCategories.push(collection);
    } else {
      collection.mainId = extractIdFromGid(collection.id);
      parentCategories.push(collection);
    }
  });

  const findParentId = (name) => {
    let foundCollectionId = null;
    for (const collection of nodes) {
      const title = collection?.title;
      if (title === name) {
        collection.haveChild = true;
        foundCollectionId =
          collection.mainId || extractIdFromGid(collection.id);
        if (!collection.mainId) {
          collection.mainId = foundCollectionId;
        }
        break;
      }
    }
    return foundCollectionId;
  };

  // Level 2: Parent > Child
  nodes.forEach((collection) => {
    const title = collection?.title || "";
    const parts = title.split(" > ").map((p) => p.trim());

    if (parts.length === 2) {
      const [parent, child] = parts;
      collection.subTitle = child;
      collection.mainId = extractIdFromGid(collection?.id);
      collection.parentTitle = parent;
      collection.parentMainId = findParentId(parent);
      childCategories.push(collection);
    }
  });

  // Level 3: Parent > Child > SubChild
  nodes.forEach((collection) => {
    const title = collection?.title || "";
    const parts = title.split(" > ").map((p) => p.trim());

    if (parts.length === 3) {
      const [parent, child, subChild] = parts;
      collection.subTitle = subChild;
      collection.subParentTitle = `${parent} > ${child}`;
      collection.mainId = extractIdFromGid(collection?.id);
      collection.parentTitle = child;
      collection.rootTitle = parent;
      collection.parentMainId = findParentId(collection.subParentTitle);
      collection.rootMainId = findParentId(parent);
      thirdChildCategories.push(collection);
    }
  });

  return {
    parentCategories,
    childCategories,
    thirdChildCategories,
    otherCategories,
  };
};

/**
 * Nest divided buckets into a tree for UI rendering.
 * Each node: { collection, label, children[] }
 */
export const buildCategoryTree = ({
  parentCategories = [],
  childCategories = [],
  thirdChildCategories = [],
} = {}) => {
  return parentCategories.map((parent) => {
    const children = childCategories
      .filter((child) => child.parentMainId === parent.mainId)
      .map((child) => {
        const grandChildren = thirdChildCategories
          .filter((third) => third.parentMainId === child.mainId)
          .map((third) => ({
            collection: third,
            label: third.subTitle || third.title,
            children: [],
          }));

        return {
          collection: child,
          label: child.subTitle || child.title,
          children: grandChildren,
        };
      });

    return {
      collection: parent,
      label: parent.title,
      children,
    };
  });
};

export const checkIfSubCategoryHaveMoreChildCategory = (
  selectedCategory,
  nLevelSubCategories
) => {
  let findCategory;
  for (const val of nLevelSubCategories || []) {
    if (val.subParentTitle === selectedCategory?.title) {
      findCategory = val;
      break;
    }
  }
  return findCategory;
};
